import React from 'react';
import ButtonSkeleton from './ButtonSkeleton';
import { useButtonUtils } from '../_hooks';
var Button = function (props) {
    var variant = props.variant, size = props.size, iconClass = props.iconClass, onClick = props.onClick, children = props.children, customClass = props.customClass, disabled = props.disabled, className = props.className;
    var createButtonClass = useButtonUtils().createButtonClass;
    return (React.createElement(ButtonSkeleton, { disabled: disabled, customClass: createButtonClass(variant, size) + " " + (customClass != null ? customClass : ''), onClick: onClick, className: className },
        iconClass && (React.createElement("i", { className: "fal " + iconClass + (children ? ' mr-2' : '') })),
        children));
};
export default React.memo(Button);
